import { Button, Divider, Drawer, List, ListItem, ListItemIcon, ListItemText, withStyles } from '@material-ui/core';
import { Menu, PowerSettingsNew, StarOutline, HighlightOff } from '@material-ui/icons';
import React, { useState } from 'react';
import { Menu as MenuInterface } from '../../helpers/datas';
import Accueil from '../../images/Accueil';
import Fidelite from '../../images/Fidelite';
import Information from '../../images/Information';
import Remboursement from '../../images/Remboursement';
import Renouvellement from '../../images/Renouvellement';
import { logout } from '../../services/Authentification/authentification';
import history from '../../services/history';
import { primaryRed } from '../../theme';
import styles from './styles';

interface Props {
  classes?: any;
  menuResponsive: (MenuInterface | undefined)[];
}

const MobileHeader = (props: Props) => {
  const { classes, menuResponsive } = props;
  const displayLimit = !window.location.hostname.startsWith('part') ? 3 : 2;
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);

  return (
    <div className={classes.mobileHeader}>
      <Button
        className={classes.mobileButton}
        classes={{
          label: classes.mobileLabelButton,
        }}
        title="Accueil"
        onClick={() => history.push('/accueil')}
      >
        <Accueil height={27} />
        <p>Accueil</p>
      </Button>
      {menuResponsive.slice(0, displayLimit).map(
        (link) =>
          link && (
            <Button
              key={link.link}
              className={classes.mobileButton}
              classes={{
                label: classes.mobileLabelButton,
              }}
              title={link.title}
              onClick={() => history.push(link.link)}
            >
              {link.title === 'Avantages' && <StarOutline className={classes.iconMaterial} />}
              {link.title === 'Renouvellement' && <Renouvellement width={36} height={25} />}
              {link.title === 'Informations' && <Information width={12} />}
              {link.title === 'Fidélité' && !window.location.hostname.startsWith('part') && (
                <Fidelite width={24} height={24} />
              )}
              {link.title === 'Remboursement' && <Remboursement width={25} color={primaryRed} />}
              {link.title === 'Résiliation' && <HighlightOff width={25} />}
              <p>{link.title}</p>
            </Button>
          ),
      )}

      <Button
        className={classes.mobileButton}
        classes={{
          label: classes.mobileLabelButton,
        }}
        title="Menu"
        onClick={() => setOpenDrawer(true)}
      >
        <Menu className={classes.iconMaterial} />
        <p>Menu</p>
      </Button>
      <Drawer
        anchor="right"
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        classes={{
          paper: classes.drawer,
        }}
      >
        <List>
          {menuResponsive.slice(displayLimit, menuResponsive.length).map(
            (link) =>
              link && (
                <ListItem button key={link.title} onClick={() => history.push(link.link)}>
                  <ListItemIcon
                    classes={{
                      root: classes.icon,
                    }}
                  >
                    {link.title === 'Avantages' && <StarOutline className={classes.iconMaterial} />}
                    {link.title === 'Renouvellement' && <Renouvellement width={36} height={25} />}
                    {link.title === 'Informations' && <Information width={16} />}
                    {link.title === 'Fidélité' && !window.location.hostname.startsWith('part') && (
                      <Fidelite width={24} height={24} />
                    )}
                    {link.title === 'Remboursement' && <Remboursement width={20} />}
                    {link.title === 'Résiliation' && <HighlightOff width={15} />}
                  </ListItemIcon>
                  <ListItemText primary={link.title} />
                </ListItem>
              ),
          )}

          <Divider />
          <ListItem button key={'deconnexion'} onClick={logout}>
            <ListItemIcon
              classes={{
                root: classes.icon,
              }}
            >
              <PowerSettingsNew />
            </ListItemIcon>
            <ListItemText primary={'Déconnexion'} />
          </ListItem>
        </List>
      </Drawer>
    </div>
  );
};
export default withStyles(styles)(MobileHeader);
